// OverdueReportModal — Admin: email yourself one person's overdue tasks.
//
// The email is written TO the chosen person, so it can be forwarded to them
// as-is with a request to update the tasks. The server decides what "overdue"
// means (due before today, Central) and sends to the caller's own address;
// this modal only picks the person and reports what happened.
import { useState } from 'react';
import { api } from '../../api/client';
import { Btn, Modal, ModalFooter, Select, useToast } from '../ui';
import { B, font } from '../../constants/brand';

export const OverdueReportModal = ({ users, onClose }) => {
  const { toast } = useToast();
  const [userId, setUserId] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const options = [
    { value: '', label: 'Choose a person…' },
    ...users
      .filter(u => u.isActive !== false && u.isInternal !== false)
      .sort((a, b) => String(a.displayName || '').localeCompare(String(b.displayName || '')))
      .map(u => ({ value: u.userID, label: u.displayName || u.email })),
  ];

  const send = async () => {
    setSending(true); setResult(null);
    try {
      const r = await api.post('task-reports/overdue', { userId });
      setResult(r);
      if (r.sent) toast.success(r.message);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <Modal title="Email overdue tasks" onClose={onClose} width={480}>
      <p style={{ fontSize: font.sm, color: B.textMd, marginTop: 0 }}>
        Sends you an email listing every open task assigned to this person that is past due.
        It is addressed to them, so you can forward it and ask them to update each task.
      </p>
      <Select label="Person" value={userId} onChange={v => { setUserId(v); setResult(null); }} options={options} />
      {result && (
        <div style={{ fontSize: font.sm, color: result.sent ? B.textMd : B.text, marginBottom: 8 }}>
          {result.message}{result.dryRun ? ' (Dry-run mode: nothing was actually delivered.)' : ''}
        </div>
      )}
      <ModalFooter>
        <Btn variant="ghost" onClick={onClose}>Close</Btn>
        <Btn onClick={send} disabled={!userId || sending} loading={sending}>Email me the list</Btn>
      </ModalFooter>
    </Modal>
  );
};
